// Stub for MessageDate component
import dayjs from "dayjs";

export const MessageDate = ({ date, timestamp }: { date?: string; timestamp?: string }) => {
  const dateValue = date || timestamp || "";
  return (
    <div className="text-center text-sm text-gray-500 my-2">
      {dayjs(dateValue).format("YYYY/MM/DD")}
    </div>
  );
};
